@import 'styles/blaze/mixins';

.root {
  display: flex;
  padding: 24px 36px 20px 36px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
  }

  .columns {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;

    .column {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
      flex: 1 1 0;
      min-width: 0;

      .originalLabel {
        padding-left: 14px;
        height: 32px;
      }

      .previewContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;

        img {
          object-fit: fill;
        }
      }

      .columnButton {
        display: flex;
        padding: 8px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        align-self: stretch;
      }
    }
  }
}

.emptyState {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 14px;
  color: var(--dark-40);
}
